import axios from 'axios';
import { getYoutubeId } from '../js/common';
import { FETCH_BOX_OPEN_SUCCESS, FETCH_BOX_NOT_OPEN_SUCCESS, FETCH_BOX_FAIL } from '../type/ActionTypes';
import { GetParam } from './payParam';

const API_URL = process.env.REACT_APP_API_URL;
var getQuery = "";

export const getBox = (tenantCode, boxCode, query) => axios.get(API_URL + '/api/service/box-client/v1.0/box/' + tenantCode + '/' + boxCode)
  .then(function (response) {
    getQuery = query;

    // TODO : 여기 생각해보기 message를 리턴하는 방향으로 했으면 좋겠음
    if (response.status !== 200)    
        throw new Error(response.status);    

    return response.data;
  }).then(function (json) {
    return fetchBoxSuccess(json);
  })
  .catch(function (error) {
    console.error(API_URL + '/api/service/box-client/v1.0/box/' + tenantCode + '/' + boxCode + "호출했는데 오류 발생");
    throw new Error(error);
  })

function fetchBoxSuccess(json) {
  // state 가공
  var tabMenu = ["story", "info"];

  // Param 세팅
  let getParam = new GetParam(getQuery);
  getParam.setDefaultParam(json.boxCode, json.selectDonationType, json.backgroundCode);

  if (json.isBoxOpen) {
      return {
          type: FETCH_BOX_OPEN_SUCCESS,
          getParam : getParam,
          payUrl: json.payUrl + "/" + json.tenantCode + "/pay/step1_direct" + getParam.getQueryString(),
          selectTab: tabMenu.indexOf(json.selectTab),
          selectDonationType: json.selectDonationType,
          brictoworksGoogleTagManager : json.brictoworksGoogleTagManager,
          googleTagManager : json.googleTagManager,
          ga4TrackingId : json.ga4TrackingId,
          googleAnalytics : json.googleAnalytics,
          isCrossDomainTrack : json.isCrossDomainTrack,
          crossDomainTrack : json.crossDomainTrack,
          data: {
              logoImgUrl: json.logoImgUrl,
              logoUrl: json.logoUrl,
              tenantCode: json.tenantCode,
              tenantName: json.tenantName,
              boxStatus: json.boxStatus,
              content:
              {
                  title: json.boxTitle,
                  tagList: json.tagNameList,
                  mainImgUrl: json.mainImgUrl,
                  isYoutubeUrl: json.isYoutubeUrl,
                  youtubeUrl: "https://www.youtube.com/embed/" + getYoutubeId(json.youtubeUrl),
                  tabMenu: ["스토리", "안내사항"],
                  tabMenuClass: tabMenu,
                  organ:
                  {
                      isOpen: json.isOpenOrgan,
                      name: json.organName,
                      info: json.organInfo
                  },
                  content0: json.storyContent,
                  content1: json.infoContent,
                  donation:
                  {
                      usePledge: json.pledge.isUse,
                      useOneOff: json.oneoff.isUse,
                      payButtonText: json.payButtonText,
                      pledge:
                      {
                          donationProgressType: json.pledge.donationProgressType,
                          title: json.pledge.title,
                          percent: json.pledge.percent,
                          monthlyPayPrice: json.pledge.payPrice,
                          memberCount: json.pledge.memberCount
                      },
                      oneOff:
                      {
                          donationProgressType: json.oneoff.donationProgressType,
                          title: json.oneoff.title,
                          percent: json.oneoff.percent,
                          payPrice: json.oneoff.payPrice,
                          memberCount: json.oneoff.memberCount
                      }
                  },
                  footer:
                  {
                      title: json.footerInfo,
                      footerlogoImgUrl: "./img/common/donuspay.png"
                  },
                  mainColor: json.mainColor,
                  mainFontColor: json.mainFontColor,
                  subColor: json.subColor,
                  subFontColor: json.subFontColor
              },
              meta: json.metaData
          }
      };
  }
  else if(!json.isBoxOpen) {
      return {
          type: FETCH_BOX_NOT_OPEN_SUCCESS,
          isRedirectUrl: json.isRedirectUrl,
          redirectUrl: json.redirectUrl,
      };
  } else{
    return {
        type: FETCH_BOX_FAIL
    };
  }  
}


// WEBPACK FOOTER //
// ./src/lib/api.js